var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.238 0.799988V4.94326H2.09473",
    stroke: "#007FFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.238 0.799988L2.09473 4.94326V15.7158C2.09473 16.4785 2.71308 17.0969 3.47582 17.0969H14.5245C15.2873 17.0969 15.9056 16.4785 15.9056 15.7158V2.18108C15.9056 1.41834 15.2873 0.799988 14.5245 0.799988H6.238Z",
    stroke: "#007FFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85645 7.56732H13.143",
    stroke: "#007FFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85645 10.3295H7.61863",
    stroke: "#007FFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85645 13.0917H7.61863",
    stroke: "#007FFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.762 13.0917C12.5247 13.0917 13.143 12.4734 13.143 11.7106C13.143 10.9479 12.5247 10.3295 11.762 10.3295C10.9992 10.3295 10.3809 10.9479 10.3809 11.7106C10.3809 12.4734 10.9992 13.0917 11.762 13.0917Z",
    stroke: "#007FFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSricon);
export default __webpack_public_path__ + "static/media/sricon.79e41f457b2f3d99c25ef25963bd611d.svg";
export { ForwardRef as ReactComponent };